import { useEffect, useRef } from "react";
import { CategorizationWithConfig } from "../../configMap/interfaces/category";
import { GetRef, Select } from "antd";
import { useAppSelector } from "../../app";

import useDynamicCategorization from "../../metadata/hooks/useDynamicCategorization";
import useCategorizationCell from "./useCategorizationCell";

type SelectRef = GetRef<typeof Select>;

const useDynamicCategorizationCell = (
  categorizationWithConfig: CategorizationWithConfig,
  index: number,
  groupBlockId: string | undefined,
  disabled: boolean,
) => {
  const selectRef = useRef<SelectRef | null>(null);

  const { activeButton, isAnnotating } = useAppSelector(
    (state) => state.appReducer,
  );

  const {
    tabId,
    handleChange,
    selectedCategory,
    categorizationOptions,
    handleFocus,
    handleBlur,
    handleSearch,
    handleFilter,
    status,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    isIncomplete,
    emptySearchResult,
    loading,
    isLoadingValue,
  } = useDynamicCategorization(categorizationWithConfig, index, groupBlockId);

  const { handleKeyEvent, onFocus, className } = useCategorizationCell(
    categorizationWithConfig,
    {
      handleFocus,
      handleSearch,
      isIncomplete,
      isCategorizationDisabledByParent,
    },
    selectRef,
    disabled,
  );

  useEffect(() => {
    if (!activeButton || !selectRef.current) {
      return;
    }

    if (activeButton.id !== tabId) {
      return;
    }

    selectRef.current.focus();
  }, [activeButton, tabId]);

  useEffect(() => {
    if (isAnnotating && selectRef.current) {
      selectRef.current.blur();
    }
  }, [isAnnotating]);

  return {
    selectRef,
    handleChange,
    selectedCategory,
    categorizationOptions,
    handleSearch,
    handleFilter,
    status,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    isIncomplete,
    emptySearchResult,
    loading,
    isLoadingValue,
    handleKeyEvent,
    onFocus,
    onBlur: handleBlur,
    className,
  };
};

export default useDynamicCategorizationCell;
